module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0063.jpg?v=100ad3da";